var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoolSummerSwimSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x35_0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M788.197-1571.144c88.705,5.973,79.16,346.885,58.384,418.989c-5.572,19.29-9.773,37.952-24.748,49.155 c-20.262-25.521-58.699-22.806-73.216,0c-15.003-11.203-18.347-30.15-24.749-49.155 C701.435-1218.657,700.149-1577.06,788.197-1571.144L788.197-1571.144z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 788.197,
    x2: 788.197,
    y1: -1559.57,
    y2: -1185.049
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 788.197,
    x2: 788.197,
    y1: -1154.898,
    y2: -1155.128
  }), /*#__PURE__*/React.createElement("path", {
    d: " M724.955-1468.004c3.515,93.452,145.432,101.167,130.257,264.122C800.857-1364.007,708.98-1304.879,724.955-1468.004 L724.955-1468.004z",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1227.717-1409.821l-0.229,17.318l312.382,0.057c-4.686,24.949-55.813,75.59-87.791,90.022 c-13.945-1.172-28.406-3.229-43.408-6.173c-54.24-13.289-103.366-14.404-146.061-0.286 c-45.639,12.031-82.589,14.232-106.566,1.715c-4.629-2.344-9.23-4.201-13.86-5.63 C1098.432-1354.265,1160.217-1409.878,1227.717-1409.821L1227.717-1409.821z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1519.467,
    x2: 1201.312,
    y1: -1357.98,
    y2: -1357.98
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1557.99-1312.569c-42.752,13.231-92.105,15.261-149.318,3.973c-54.24-13.289-103.366-14.404-146.061-0.286 c-45.639,12.031-82.589,14.232-106.566,1.715c-24.348-12.46-48.696-10.975-73.044-3.229",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1501.436-1258.242c-36.266,3.602-75.275,7.06-115.426-12.745c-31.693-12.118-62.9-20.634-102.537-0.258 c-68.93,26.778-112.682,9.803-126.685,5.83c-14.003-4.001-32.807-19.319-56.098-6.459",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1527.469,
    x2: 1541.072,
    y1: -1262.786,
    y2: -1265.615
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    points: " 1279.243,-1439 1278.9,-1392.474 1413.158,-1392.332 1335.941,-1438.915 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1315.851,
    x2: 1315.937,
    y1: -1438.943,
    y2: -1392.217
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1169.533,
    x2: 1131.268,
    y1: -1359.781,
    y2: -1359.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M228.949-1512.464v353.915c-1.714,50.813-78.103,62.358-100.622,0l-79.274-333.282 C45.48-1563.02,224.463-1575.794,228.949-1512.464L228.949-1512.464z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M88.69-1325.189c40.237-39.724,86.619-48.612,140.259-21.234",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M108.78-1240.683c37.637-62.645,78.074-58.015,120.169-13.317",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 86.404,
    x2: 111.552,
    y1: -1492.345,
    y2: -1386.69
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 138.901,
    x2: 150.132,
    y1: -1510.149,
    y2: -1391.72
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 189.369,
    x2: 190.37,
    y1: -1467.167,
    y2: -1396.75
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 188.712,
    x2: 188.712,
    y1: -1500.032,
    y2: -1500.29
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M290.763-1512.464v353.915c1.715,50.813,78.103,62.358,100.622,0l79.274-333.282 C474.232-1563.02,295.25-1575.794,290.763-1512.464L290.763-1512.464z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M431.022-1325.189c-40.237-39.724-86.619-48.612-140.259-21.234",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M410.932-1240.683c-37.637-62.645-78.074-58.015-120.169-13.317",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 433.308,
    x2: 408.16,
    y1: -1492.345,
    y2: -1386.69
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 380.811,
    x2: 369.581,
    y1: -1510.149,
    y2: -1391.72
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 330.343,
    x2: 329.343,
    y1: -1467.167,
    y2: -1396.75
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 331,
    x2: 331,
    y1: -1500.032,
    y2: -1500.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1619.743-1366.039l105.452-35.151l40.18,22.605h263.658c67.5,0.657,90.162,79.477,20.89,89.45c0-0.314,0-0.628,0-0.942 c0-22.206-17.976-40.182-40.151-40.182c-22.205,0-40.181,17.976-40.181,40.182c0,0.628,0,1.257,0.029,1.886h-218.706 c0.029-0.629,0.029-1.258,0.029-1.886c0-22.206-17.976-40.182-40.18-40.182c-22.177,0-40.181,17.976-40.181,40.182 c0,0.171,0,0.314,0.028,0.485L1619-1306.11L1619.743-1366.039z",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    points: " 1860.167,-1442 1919.18,-1378.584 1765.375,-1378.584 1725.195,-1401.19 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1710.764-1249.896c22.146,0,40.18-18.062,40.18-40.181c0-22.12-18.033-40.182-40.18-40.182 c-22.119,0-40.181,18.062-40.181,40.182C1670.583-1267.958,1688.645-1249.896,1710.764-1249.896L1710.764-1249.896z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2009.771-1249.896c22.119,0,40.151-18.062,40.151-40.181c0-22.12-18.032-40.182-40.151-40.182 c-22.147,0-40.181,18.062-40.181,40.182C1969.591-1267.958,1987.624-1249.896,2009.771-1249.896L2009.771-1249.896z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1771.033,
    x2: 1897.833,
    y1: -1337.203,
    y2: -1337.203
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2058.554,
    x2: 2089.617,
    y1: -1341.546,
    y2: -1341.089
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: " 1649.235,-1330.258 1626.658,-1330.544 1619.314,-1330.629 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1815.186,
    x2: 1842.277,
    y1: -1428.397,
    y2: -1378.584
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1938.385,
    x2: 1938.385,
    y1: -1335.602,
    y2: -1335.86
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2009.771,
    x2: 2009.771,
    y1: -1289.848,
    y2: -1290.077
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1710.764,
    x2: 1710.764,
    y1: -1289.848,
    y2: -1290.077
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2215.998-1427.584c-26.377,33.266-35.837,74.99-36.351,121.173v76.934h11.574c7.858,0,14.26,6.43,14.26,14.26v0.887h29.264 c0.657-21.52,18.289-38.753,39.98-38.753c21.662,0,39.322,17.233,39.951,38.753h132.687c0.629-21.52,18.289-38.753,39.951-38.753 c21.69,0,39.323,17.233,39.98,38.753h36.036v-0.887c0-7.83,6.431-14.26,14.261-14.26h11.574v-78.134 c2.143-39.981-6.173-79.991-26.635-119.973H2215.998z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2302.017-1459.077h307.754c-11.889-18.891-31.722-31.179-63.015-33.923h-182.954 C2337.139-1490.799,2315.763-1480.683,2302.017-1459.077L2302.017-1459.077z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2234.573-1368.541h52.526c7.458,0,13.546,6.116,13.546,13.575v21.348c0,7.459-6.088,13.547-13.546,13.547h-52.526 c-7.486,0-13.574-6.088-13.574-13.547v-21.348C2220.999-1362.425,2227.087-1368.541,2234.573-1368.541L2234.573-1368.541z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2485.143-1368.541h52.526c7.458,0,13.546,6.116,13.546,13.575v21.348c0,7.459-6.088,13.547-13.546,13.547h-52.526 c-7.487,0-13.574-6.088-13.574-13.547v-21.348C2471.568-1362.425,2477.655-1368.541,2485.143-1368.541L2485.143-1368.541z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2363.63-1368.541h52.526c7.487,0,13.574,6.116,13.574,13.575v21.348c0,7.459-6.087,13.547-13.574,13.547h-52.526 c-7.458,0-13.545-6.088-13.545-13.547v-21.348C2350.085-1362.425,2356.172-1368.541,2363.63-1368.541L2363.63-1368.541z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2197.251,
    x2: 2507.634,
    y1: -1396.062,
    y2: -1396.062
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2466.796,
    x2: 2486.172,
    y1: -1281.862,
    y2: -1281.862
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2600.769-1229.478h-23.177c-7.83,0-14.261,6.43-14.261,14.26v1.772c0,7.859,6.431,14.261,14.261,14.261h23.177 c7.83,0,14.231-6.401,14.231-14.261v-1.772C2615-1223.048,2608.599-1229.478,2600.769-1229.478L2600.769-1229.478z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2191.222-1229.478h-23.148c-7.859,0-14.26,6.43-14.26,14.26v1.772c0,7.859,6.4,14.261,14.26,14.261h23.148 c7.858,0,14.26-6.401,14.26-14.261v-1.772C2205.481-1223.048,2199.08-1229.478,2191.222-1229.478L2191.222-1229.478z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M2582.507-1312.47c2.115,0,4.144,0.429,6.059,1.2v46.068c-1.915,0.771-3.943,1.2-6.059,1.2c-10.717,0-19.376-10.859-19.376-24.234 S2571.79-1312.47,2582.507-1312.47L2582.507-1312.47z",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2274.726-1173.121c22.004,0,39.98-17.976,39.98-39.981c0-22.034-17.977-39.981-39.98-39.981c-22.033,0-39.98,17.947-39.98,39.981 C2234.745-1191.097,2252.692-1173.121,2274.726-1173.121L2274.726-1173.121z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2487.314-1173.121c22.033,0,39.98-17.976,39.98-39.981c0-22.034-17.947-39.981-39.98-39.981 c-22.005,0-39.979,17.947-39.979,39.981C2447.335-1191.097,2465.31-1173.121,2487.314-1173.121L2487.314-1173.121z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2274.726,
    x2: 2274.726,
    y1: -1213.103,
    y2: -1213.359
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2487.314,
    x2: 2487.314,
    y1: -1212.874,
    y2: -1213.103
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2386.836,
    x2: 2386.836,
    y1: -1484.512,
    y2: -1427.584
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2522.522,
    x2: 2522.522,
    y1: -1486.941,
    y2: -1427.584
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 345.07,-845.926 418,-845.926 418,-808.66 353.187,-808.66 353.187,-831.351 345.07,-831.351 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M94.786-831.351h258.4v63.987c-19.147,22.691-44.324,31.322-76.417,23.777l-51.583-55.356l-55.068,60.758 c-28.321,0.743-53.469-8.059-75.332-26.749V-831.351z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    points: " 224.387,-721.981 265.853,-755.304 225.187,-798.943 181.405,-750.617 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M182.263-695.661c-0.943,17.919,3.229,29.607,25.12,30.379h34.007c18.805-0.914,23.063-10.459,23.092-27.549",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("rect", {
    clipRule: "evenodd",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    height: 184.274,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    width: 31.607,
    x: 375.048,
    y: -1029
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M403.397-653.937V-808.66h-30.778v157.153c-14.546,27.063-35.122,42.039-64.786,38.866c-39.266-2.571-61.728-19.833-66.443-52.642 h-34.007c8.03,49.184,51.211,85.907,102.08,83.964C358.216-583.204,395.281-604.353,403.397-653.937L403.397-653.937z",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M139.739-892.109h182.269c6.888,0,12.546,5.658,12.546,12.574l0,0c0,6.888-5.658,12.546-12.546,12.546H139.739 c-6.916,0-12.545-5.658-12.545-12.546l0,0C127.194-886.451,132.823-892.109,139.739-892.109L139.739-892.109z",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M101.274-831.351c-5.173-14.861-0.286-27.578,24.805-35.98l4.315-3.858",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 406.655,
    x2: 375.048,
    y1: -970.671,
    y2: -970.671
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M552.869-745.329c19.118-10.174,35.351-10.831,47.667,1.686c18.375,18.405,42.324,22.491,76.587,0 c21.091-12.031,51.012-16.347,69.816,0c28.663,22.463,51.039,22.949,80.018,0c22.262-16.918,47.81-13.432,68.071,3.401 c28.378,18.547,56.756,18.376,85.133-1.687c6.088-8.773,21.119-7.116,40.838,0",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M636.287-695.974c40.294-5.858,76.846-38.695,114.911-3.4c20.434,11.517,45.639,12.603,77.445-0.857 c30.436-14.946,56.955-17.09,78.303-2.544c18.919,14.89,46.354,14.061,69.815,1.715",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M693.3-671.282c17.461-7.345,34.064-8.23,47.668,2.543c24.862,11.975,50.354,16.147,77.474,0.857 c20.062-5.572,37.494-9.717,61.271-0.857",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M876.911-847.154c-20.318-22.434-49.668-36.495-82.304-36.495 c-58.499,0-106.423,45.183-110.767,102.568c-0.229,2.973-1.543,8.145,1.086,8.145l216.133-0.313 C895.258-810.402,891.058-828.178,876.911-847.154L876.911-847.154z",
    fill: "#F5D8B3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 788.635,
    x2: 788.635,
    y1: -970.898,
    y2: -918.972
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 921.436,
    x2: 883.112,
    y1: -913.027,
    y2: -875.561
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 853.335,
    x2: 840.561,
    y1: -926.63,
    y2: -908.769
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 723.964,
    x2: 735.88,
    y1: -927.488,
    y2: -908.541
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 640.546,
    x2: 662.665,
    y1: -842.381,
    y2: -829.607
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 598.822,
    x2: 655.005,
    y1: -780.223,
    y2: -780.223
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 925.265,
    x2: 942.926,
    y1: -835.979,
    y2: -839.609
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M577.103-878.962h119.169c26.377-52.784-60.214-63.444-68.102-28.95C597.793-927.631,566.043-909.483,577.103-878.962 L577.103-878.962z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M823.242-783.709h118.312c3.287-26.55-13.889-32.208-49.354-28.093C847.248-839.238,816.27-814.746,823.242-783.709 L823.242-783.709z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M876.911-847.154c-20.318-22.434-49.668-36.495-82.304-36.495c-58.499,0-106.423,45.183-110.767,102.568",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: " 1215.069,-917.197 1197.608,-881.646 1236.788,-861.412 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1415.97-859.897C1495.616-848.58,1551-823.574,1551-794.51c0,39.667-103.138,71.817-230.365,71.817 c-127.199,0-230.336-32.15-230.336-71.817c0-21.063,29.092-40.01,75.444-53.156l54.299,12.174l16.746-25.921 c-8.916,20.063-14.289,43.325-14.975,68.274c65.614,38.952,135.658,33.322,208.503,0 C1429.658-817.458,1424.515-840.207,1415.97-859.897L1415.97-859.897z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1326.064-930c56.298,0,102.165,60.786,104.252,136.862c-72.845,33.322-142.889,38.952-208.503,0 C1223.899-869.214,1269.767-930,1326.064-930L1326.064-930z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: " 1179.376,-891.048 1165.743,-847.666 1220.042,-835.491 1236.788,-861.412 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1378.162-812.886c-57.527,20.834-104.595,13.632-150.062-13.403",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1404.996,
    x2: 1404.996,
    y1: -821.717,
    y2: -821.945
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1702.418-677.728c6.887-85.021,93.277-120.544,171.58-113.514l-0.486,0.457c-0.743,0.687-1.485,1.372-2.229,2.058l-0.486,0.457 c-0.8,0.715-1.601,1.43-2.4,2.173l-0.457,0.428c-0.801,0.715-1.601,1.43-2.4,2.144l-0.458,0.429 c-0.886,0.771-1.771,1.572-2.657,2.372l-0.086,0.086l-0.028,0.028l-0.086,0.058c-0.914,0.8-1.829,1.629-2.771,2.458l-0.258,0.229 c-1,0.886-1.972,1.743-2.972,2.629h-0.028l0,0c-1.029,0.914-2.087,1.857-3.173,2.772l33.208,19.348 c1.057-1.258,2.114-2.516,3.172-3.744l0.2-0.229l0.085-0.086c1.029-1.229,2.029-2.4,3.029-3.601l0.343-0.4 c0.887-1.028,1.744-2.058,2.63-3.087l0.8-0.972c0.715-0.856,1.429-1.686,2.115-2.543l1.2-1.4c0.543-0.686,1.086-1.343,1.657-2 c0.515-0.629,1.058-1.286,1.571-1.915l0.943-1.144l0.372-0.457c0.657-0.771,1.285-1.543,1.914-2.314l0.372-0.458l0.171-0.199 c0.687-0.857,1.372-1.715,2.058-2.544l0.343-0.457l0.372-0.429c0.714-0.915,1.429-1.801,2.144-2.687l0.343-0.429 c52.926,15.175,94.049,51.984,90.22,107.855c-36.608,26.892-61.07,30.578-95.964,8.459 c-47.382-34.694-85.677-12.261-122.484-0.058C1753.343-657.837,1728.537-651.606,1702.418-677.728L1702.418-677.728z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1993.796-984.746c20.719,0,38.693,11.717,47.695,28.893h-95.421C1955.072-973.029,1973.076-984.746,1993.796-984.746 L1993.796-984.746z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1910.948-1008.752c14.403,7.773,22.491,22.691,22.291,37.981l-66.3-35.866 C1879.628-1015.182,1896.546-1016.554,1910.948-1008.752L1910.948-1008.752z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1966.104-1008.752c-14.403,7.773-22.49,22.691-22.29,37.981l66.3-35.866C1997.425-1015.182,1980.507-1016.554,1966.104-1008.752 L1966.104-1008.752z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1891.287-984.746c20.719,0,38.723,11.717,47.696,28.893h-95.392C1852.564-973.029,1870.568-984.746,1891.287-984.746 L1891.287-984.746z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1891.116-938.735c12.06-11.66,29.092-14.975,43.98-10.06l-55.44,53.67C1875.227-910.156,1879.085-927.075,1891.116-938.735 L1891.116-938.735z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1998.739-938.735c-12.06-11.66-29.092-14.975-43.98-10.06l55.44,53.67C2014.629-910.156,2010.771-927.075,1998.739-938.735 L1998.739-938.735z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1853.021-772.465c68.358-59.615,88.819-87.822,91.335-190.133c20.032,107.055,15.26,123.602-58.127,209.48L1853.021-772.465z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1622-678.328c26.977-5.372,36.493-5.029,55.897,18.319c18.861,23.863,43.152,33.408,74.188,34.094 c39.122,0.114,54.525-26.949,92.963-27.121c39.951,1.601,51.383,23.635,90.477,32.037c29.007,7.23,55.498-14.146,89.963-34.866 c34.922-20.891,41.98-17.947,60.585-4.087",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1676.926-615.598c24.834,21.434,49.84,27.235,72.873,28.178c39.952,0.715,59.984-30.836,93.535-28.407 c55.498,11.432,84.476,57.071,150.404,16.204",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2029.832,
    x2: 2057.181,
    y1: -619.284,
    y2: -634.574
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1661.723-952.481c-33.551-10.688-14.889-58.271,21.233-37.667c-11.146-44.64,67.129-48.641,55.955,1.086 c28.006-31.951,68.358,16.861,32.292,36.581H1661.723z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1751.229-884.75c-29.521-11.231,10.287-67.216,48.953-23.206c20.461-23.292,46.067,14.089,20.49,23.206H1751.229z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1656.893,
    x2: 1656.893,
    y1: -635.889,
    y2: -636.089
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 2340.108,-877.125 2442.273,-877.125 2447.046,-768.383 2429.5,-768.383 2429.5,-739.576 2402.322,-739.576 2402.322,-768.069 2372.687,-768.04 2372.516,-739.462 2347.31,-739.233 2347.31,-768.383 2328.534,-768.583 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 2179.645,-604.657 2188.161,-760.524 2216.31,-760.524 2221.54,-836.514 2292.298,-836.514 2292.298,-764.468 2317.161,-763.153 2317.732,-604.571 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 2592.621,-603.485 2587.02,-761.839 2564.729,-763.153 2564.729,-833.885 2490.084,-833.885 2490.084,-765.782 2462.564,-764.468 2461.249,-603.343 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 2347.31,-768.383 2317.161,-768.727 2317.732,-604.571 2461.249,-603.343 2462.25,-768.383 2429.5,-768.383 2429.5,-739.576 2402.322,-739.576 2402.322,-768.069 2372.687,-768.04 2372.516,-739.462 2347.31,-739.233 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    points: " 2361.228,-935.882 2421.47,-935.882 2427.699,-877.125 2354.026,-877.125 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2388.063,
    x2: 2388.063,
    y1: -1002.698,
    y2: -935.882
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    points: " 2435.559,-982.722 2388.063,-959.487 2388.063,-1002.698 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2252.661,
    x2: 2252.661,
    y1: -902.331,
    y2: -836.514
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    points: " 2294.585,-881.697 2252.661,-860.406 2252.661,-902.331 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2523.806,
    x2: 2523.806,
    y1: -903.959,
    y2: -833.885
  }), /*#__PURE__*/React.createElement("polygon", {
    clipRule: "evenodd",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    points: " 2567.701,-883.012 2523.806,-860.749 2523.806,-903.959 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2389.377-815.709c8.659,0,15.718-7.059,15.718-15.718s-7.059-15.718-15.718-15.718s-15.718,7.059-15.718,15.718 S2380.718-815.709,2389.377-815.709L2389.377-815.709z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2252.946-696.623c8.66,0,15.719-7.059,15.719-15.718c0-8.631-7.059-15.718-15.719-15.718c-8.658,0-15.717,7.087-15.717,15.718 C2237.229-703.682,2244.288-696.623,2252.946-696.623L2252.946-696.623z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2526.949-694.68c8.659,0,15.718-7.059,15.718-15.718s-7.059-15.718-15.718-15.718c-8.658,0-15.718,7.059-15.718,15.718 S2518.291-694.68,2526.949-694.68L2526.949-694.68z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2382.118-685.42h12.231c13.488,0,24.49,11.003,24.49,24.491v57.157h-61.213v-57.157 C2357.627-674.417,2368.63-685.42,2382.118-685.42L2382.118-685.42z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2236.629,
    x2: 2216.31,
    y1: -760.524,
    y2: -760.524
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2548.04,
    x2: 2575.875,
    y1: -762.496,
    y2: -762.496
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2522.034,
    x2: 2522.034,
    y1: -761.667,
    y2: -761.867
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2260.663,
    x2: 2260.663,
    y1: -760.839,
    y2: -761.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 2146.238,
    x2: 2625,
    y1: -603,
    y2: -603
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2376.983-447.458h8.46c6.973,0,12.688,5.716,12.688,12.689v13.804l-16.918-3.916l-16.947,3.772v-13.661 C2364.267-441.742,2369.982-447.458,2376.983-447.458L2376.983-447.458z",
    fill: "#F4B1C3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2242.812-394.13l138.402-30.75l133.915,31.093c12.06,3.487,22.033,7.23,26.806,19.776l31.178,163.612l31.521,57.157 c19.262,34.923,12.488,23.806-27.12,16.918c-127.257-22.091-254.513-24.377-381.77-1.571 c-40.466,7.259-52.726,21.319-32.406-14.575l34.436-60.758l28.092-160.783C2227.037-384.643,2233.038-391.015,2242.812-394.13 L2242.812-394.13z",
    fill: "#DCF2FF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    d: " M2197.773-213.229c131.086-30.865,255.542-26.521,375.339,2.829",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2376.069-335.287c-72.273-70.846-101.594,45.84-9.174,20.833c-52.84,50.841,16.519,61.215,22.52,12.432 c50.697,69.074,72.33-41.182,9.917-26.006C2464.089-373.726,2361.237-404.361,2376.069-335.287L2376.069-335.287z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1652.305-257.244c2.858-30.036,16.49-44.497,38.608-46.668h117.455c26.177,8.316,32.807,29.264,22.52,61.158 c-23.463,113.456-178.153,110.941-178.583,50.67V-257.244z",
    fill: "#929FC5",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2057.308-257.244c-2.829-30.036-16.46-44.497-38.608-46.668h-117.426c-26.205,8.316-32.807,29.264-22.547,61.158 c23.462,113.456,178.182,110.941,178.581,50.67V-257.244z",
    fill: "#929FC5",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: " 1673.624,-394.392 1622.156,-344.522 1622.156,-250.414 1652.305,-250.414 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: " 2035.503,-394.392 2087,-344.522 2087,-250.414 2056.822,-250.414 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1808.368,
    x2: 1901.273,
    y1: -303.912,
    y2: -303.912
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1835.03,
    x2: 1874.611,
    y1: -260.702,
    y2: -260.702
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1745.211,
    x2: 1688.112,
    y1: -268.904,
    y2: -202.945
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1774.018,
    x2: 1751.813,
    y1: -247.012,
    y2: -220.035
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1958.887,
    x2: 2015.984,
    y1: -268.904,
    y2: -202.945
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1930.08,
    x2: 1952.313,
    y1: -247.012,
    y2: -220.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1332.797-501.2c113.939,4.944,205.873,94.88,213.904,208.022c-1.43-0.457-2.943-0.686-4.486-0.686h-32.408h-0.057 c-8.174-91.937-82.646-164.812-175.324-170.442v-29.921C1334.426-496.742,1333.826-499.114,1332.797-501.2L1332.797-501.2z M1546.873-263.198c-6.916,113.742-98.508,204.593-212.533,210.309c0.057-0.6,0.086-1.2,0.086-1.8v-32.408 c0-0.886-0.057-1.772-0.199-2.63c93.506-5.572,168.578-79.647,175.723-172.756h32.266 C1543.814-262.483,1545.387-262.713,1546.873-263.198L1546.873-263.198z M1303.047-463.619 c-88.791,9.316-159.121,80.591-167.065,169.785c-0.286,0-0.6-0.028-0.886-0.028h-32.407c-1.257,0-2.458,0.143-3.629,0.428 c7.945-110.17,95.478-198.306,205.388-207.251c-0.887,1.972-1.4,4.173-1.4,6.459V-463.619z M1135.811-262.483 c6.916,90.394,77.875,162.868,167.58,172.099c-0.229,1.058-0.343,2.172-0.343,3.287v32.408c0,0.399,0.028,0.8,0.057,1.229 c-110.053-9.631-197.329-98.653-204.187-209.48c1.2,0.314,2.458,0.458,3.772,0.458h32.407 C1135.325-262.483,1135.554-262.483,1135.811-262.483L1135.811-262.483z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1334.426-463.276c92.105,5.63,166.15,78.048,174.324,169.471c-8.145,0.543-14.633,7.373-14.633,15.632l0,0 c0,8.345,6.574,15.232,14.832,15.661c-7.145,92.623-81.875,166.298-174.953,171.785c-1.629-6.887-7.857-12.06-15.259-12.06l0,0 c-7.145,0-13.203,4.829-15.09,11.402c-89.305-9.116-159.949-81.248-166.836-171.185c7.83-0.857,13.975-7.545,13.975-15.604l0,0 c0-7.974-6.059-14.604-13.775-15.575c7.859-88.679,77.789-159.525,166.037-168.842v0.771c0,8.631,7.059,15.69,15.689,15.69l0,0 c8.63,0,15.689-7.059,15.689-15.69V-463.276z M1322.881-361.623c46.725,0,84.59,37.895,84.59,84.592 c0,46.726-37.865,84.621-84.59,84.621c-46.725,0-84.59-37.896-84.59-84.621C1238.291-323.728,1276.156-361.623,1322.881-361.623 L1322.881-361.623z",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1467.826,
    x2: 1382.693,
    y1: -394.574,
    y2: -336.845
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1175.448,
    x2: 1260.552,
    y1: -394.574,
    y2: -336.845
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1175.448,
    x2: 1260.552,
    y1: -159.173,
    y2: -216.93
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1467.826,
    x2: 1382.693,
    y1: -159.173,
    y2: -216.93
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1318.737-102.787L1318.737-102.787c8.63,0,15.689,7.059,15.689,15.689v32.408c0,8.63-7.059,15.689-15.689,15.689l0,0 c-8.631,0-15.689-7.06-15.689-15.689v-32.408C1303.047-95.729,1310.106-102.787,1318.737-102.787L1318.737-102.787z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1318.737-509.916L1318.737-509.916c8.63,0,15.689,7.059,15.689,15.689v32.408c0,8.631-7.059,15.69-15.689,15.69l0,0 c-8.631,0-15.689-7.059-15.689-15.69v-32.408C1303.047-502.857,1310.106-509.916,1318.737-509.916L1318.737-509.916z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1087-278.173L1087-278.173c0-8.631,7.059-15.689,15.689-15.689h32.407c8.63,0,15.689,7.059,15.689,15.689l0,0 c0,8.63-7.059,15.69-15.689,15.69h-32.407C1094.059-262.483,1087-269.543,1087-278.173L1087-278.173z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1494.117-278.173L1494.117-278.173c0-8.631,7.059-15.689,15.689-15.689h32.408c8.629,0,15.688,7.059,15.688,15.689l0,0 c0,8.63-7.059,15.69-15.688,15.69h-32.408C1501.176-262.483,1494.117-269.543,1494.117-278.173L1494.117-278.173z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M769.533-48c-8.316-51.299-34.15-85.05-78.56-100.225v-130.032c-61.985-8.659-60.757-108.141-10.831-121.916l2.457,0.028v-100.625 h27.264c8.116,93.994-29.578,144.064,69.873,156.267c100.735-6.744,79.702-80.706,81.132-156.267h27.263v103.311h0.601 c51.325,24.806,45.724,105.34-1.372,119.201l-1.343,127.317C836.662-134.821,807.57-100.271,797.969-48H769.533z",
    fill: "#FDB7CA",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 717.207,
    x2: 687.744,
    y1: -278.6,
    y2: -278.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 886.159,
    x2: 856.695,
    y1: -277.256,
    y2: -277.256
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 741.584,
    x2: 741.584,
    y1: -276.856,
    y2: -277.085
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M255.928-44c24.891-34.666,53.097-43.611,75.302-60.673c46.582-35.809,79.646-65.559,95.05-122.944l25.462,17.233l-8.43-106.198 l-64.357,66.245l20.833,17.062c-16.261,31.551-82.161,119.743-113.567,58.672l-9.859-175.015h59.07v-35.98h-61.1l-2.114-37.752 c16.889-5.315,29.12-21.091,29.12-39.724c0-23.005-18.633-41.639-41.638-41.639s-41.637,18.633-41.637,41.639 c0,15.861,8.858,29.636,21.89,36.667l-2.028,40.81h-55.813v35.98h54.04L227.55-176.49c-41.466,59.301-84.533-25.32-114.511-59.644 l19.861-25.549L70.43-310.895L64-204.897l20.633-21.776c20.689,54.585,62.1,95.538,99.393,124.059 C205.145-88.154,231.952-76.78,255.928-44L255.928-44z",
    fill: "#929FC5",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 256.871,
    x2: 256.871,
    y1: -106.473,
    y2: -56.317
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 256.871,
    x2: 256.871,
    y1: -143.368,
    y2: -143.653
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 258.786,
    x2: 258.786,
    y1: -465.161,
    y2: -465.447
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2402.926,227.935c31.636,6.087,54.813,25.921,54.813,49.44c0,8.603-3.059,16.747-8.573,23.863 c-7.802,10.031-15.032,26.378-3.744,37.238c16.689,16.004,34.579,40.324,34.579,67.33c0,46.783-40.266,85.021-91.22,87.993v0.2 c-1.058,0-2.115-0.028-3.173-0.057c-1.085,0.028-2.144,0.057-3.2,0.057v-0.2c-50.926-2.972-91.221-41.21-91.221-87.993 c0-27.006,17.891-51.326,34.58-67.33c11.287-10.86,4.058-27.207-3.715-37.238c-5.516-7.116-8.603-15.261-8.603-23.863 c0-24.92,26.006-45.668,60.499-50.383v114.142c4.144-1.943,8.773-3.058,13.688-3.058c5.516,0,10.745,1.4,15.289,3.858V227.935z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2373.948,87.5h28.978v254.435c-4.544-2.458-9.773-3.858-15.289-3.858c-4.915,0-9.545,1.114-13.688,3.058V87.5z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2387.637,402.492c17.719,0,32.179-14.461,32.179-32.208c0-17.719-14.46-32.208-32.179-32.208 c-17.747,0-32.207,14.489-32.207,32.208C2355.43,388.031,2369.89,402.492,2387.637,402.492L2387.637,402.492z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 2357.03,
    x2: 2421.444,
    y1: 425.812,
    y2: 425.812
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M2376.349,22.57h26.577c5.744,0,10.46,4.715,10.46,10.46v41.867c0,5.744-4.716,10.46-10.46,10.46h-26.577 c-5.744,0-10.459-4.716-10.459-10.46V33.03C2365.89,27.285,2370.604,22.57,2376.349,22.57L2376.349,22.57z",
    fill: "#DBBEB9",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1884.473,346.879v110.342c0,18.318-15.004,33.322-33.351,33.322l0,0c-18.318,0-33.321-15.004-33.321-33.322V346.879H1884.473z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1851.951,26L1851.951,26c60.527,0,110.024,49.498,110.024,109.999v191.276c0.514,14.403-7.059,20.747-22.091,19.604h-177.496 c-15.976,0-21.119-5.001-20.433-18.776V135.999C1741.956,75.498,1791.452,26,1851.951,26L1851.951,26z",
    fill: "#F4B1C3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1810.171,113.993L1810.171,113.993c9.945,0,18.09,8.117,18.09,18.062v150.551c0,9.917-8.145,18.062-18.09,18.062l0,0 c-9.917,0-18.062-8.145-18.062-18.062V132.055C1792.109,122.109,1800.254,113.993,1810.171,113.993L1810.171,113.993z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1893.761,113.993L1893.761,113.993c9.916,0,18.061,8.117,18.061,18.062v150.551c0,9.917-8.145,18.062-18.061,18.062l0,0 c-9.945,0-18.09-8.145-18.09-18.062V132.055C1875.671,122.109,1883.815,113.993,1893.761,113.993L1893.761,113.993z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M1784.422,88.729c0,0,15.003-41.667,65.843-34.18",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 1882.815,
    x2: 1882.815,
    y1: 65.181,
    y2: 64.981
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1296.929,240.053L1130.75,115.736c-9.802-7.345-11.917-21.263-4.658-30.979l0,0c7.23-9.688,21.205-11.603,31.036-4.23 l139.801,104.569V240.053z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1535.382,253.913v190.476c0,26.206-18.633,47.611-41.409,47.611h-354.563c-22.776,0-41.409-21.405-41.409-47.611V253.913h198.929 v42.039c-7.858,5.916-12.945,15.289-12.945,25.892c0,17.862,14.489,32.352,32.35,32.352c17.891,0,32.351-14.489,32.351-32.352 c0-10.603-5.059-19.976-12.917-25.892v-42.039H1535.382z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1316.333,19.027L1316.333,19.027c10.688,0,19.434,8.745,19.434,19.405v257.521c7.858,5.916,12.917,15.289,12.917,25.892 c0,17.862-14.46,32.352-32.351,32.352c-17.86,0-32.35-14.489-32.35-32.352c0-10.603,5.087-19.976,12.945-25.892V38.432 C1296.929,27.771,1305.675,19.027,1316.333,19.027L1316.333,19.027z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M1340.854,208.616h189.298c10.746,0,19.519,9.888,19.519,21.977l0,0c0,12.117-8.772,22.005-19.519,22.005h-189.298V208.616z",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1335.767,
    x2: 1536.039,
    y1: 290.122,
    y2: 290.122
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1166.587,
    x2: 1292.757,
    y1: 290.122,
    y2: 290.122
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 1127.121,
    x2: 1127.121,
    y1: 292.294,
    y2: 292.065
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M897.473,189.697v102.196c0,38.152-46.01,69.36-102.251,69.36 H776.36c-56.241,0-102.251-31.208-102.251-69.36V189.697H897.473z",
    fill: "#F5D8B3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M897.473,49.748c32.321,0,58.527,26.207,58.527,58.529s-26.206,58.528-58.527,58.528v-58.528h-58.527 C838.945,75.955,865.151,49.748,897.473,49.748L897.473,49.748z",
    fill: "#F9E5D3",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M800.537,450.333c46.096,1.485,81.246,9.23,81.246,18.576c0,10.402-43.58,18.833-97.335,18.833s-97.336-8.431-97.336-18.833 c0-9.603,37.151-17.548,85.161-18.69v-89.051c1.344,0.058,2.715,0.086,4.087,0.086h18.861c1.771,0,3.544-0.058,5.315-0.144 V450.333z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    d: " M897.473,108.277V259c0,56.242-46.01,102.254-102.251,102.254H776.36c-56.241,0-102.251-46.012-102.251-102.254V108.277H897.473z",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 898.33,
    x2: 898.33,
    y1: 49.833,
    y2: 108.277
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 898.616,
    x2: 950.713,
    y1: 108.563,
    y2: 108.563
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 898.502,
    x2: 938.854,
    y1: 105.248,
    y2: 146.857
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 942.626,
    x2: 901.531,
    y1: 71.039,
    y2: 106.619
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 859.121,
    x2: 899.502,
    y1: 63.923,
    y2: 105.533
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764,
    x1: 674.109,
    x2: 897.473,
    y1: 189.697,
    y2: 189.697
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M787.049,335.561c8.858,0,16.089-7.23,16.089-16.118c0-8.859-7.23-16.09-16.089-16.09c-8.859,0-16.09,7.23-16.09,16.09 C770.959,328.331,778.189,335.561,787.049,335.561L787.049,335.561z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M840.946,294.637c8.459,0,15.346-6.888,15.346-15.347c0-8.46-6.887-15.347-15.346-15.347s-15.347,6.887-15.347,15.347 C825.6,287.75,832.487,294.637,840.946,294.637L840.946,294.637z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: " M815.655,244.596c6.858,0,12.46-5.601,12.46-12.46s-5.602-12.46-12.46-12.46c-6.888,0-12.46,5.602-12.46,12.46 S808.768,244.596,815.655,244.596L815.655,244.596z",
    fill: "#B0F0A8",
    fillRule: "evenodd",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: " 600.293,29 715.318,39.717 740.268,187.468 ",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1764
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M110.692,135.484c0.886-72.847,100.993-69.76,98.422,0v237.201",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    d: " M272.985,135.484c0.857-72.847,100.993-69.76,98.422,0v237.201",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("rect", {
    clipRule: "evenodd",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    height: 32.379,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    width: 162.293,
    x: 209.114,
    y: 182.353
  }), /*#__PURE__*/React.createElement("rect", {
    clipRule: "evenodd",
    fill: "#F5D8B3",
    fillRule: "evenodd",
    height: 32.38,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    width: 162.293,
    x: 209.114,
    y: 279.719
  }), /*#__PURE__*/React.createElement("path", {
    d: " M40.792,361.053c21.69-15.432,42.209-23.548,68.3-8.83c26.807,17.261,61.985,33.779,100.022,20.462 c37.78-18.176,55.354-25.692,77.674-9.06c24.034,17.376,51.954,21.034,84.619,9.06c38.465-17.147,71.387-28.264,99.593,1.058",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("path", {
    d: " M96.633,410.437c40.294,5.858,76.845,38.724,114.882,3.401c20.462-11.518,45.667-12.575,77.475,0.857 c30.435,14.975,56.927,17.118,78.303,2.571c18.918-14.889,46.353-14.061,69.786-1.714",
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 20.1478,
    x1: 61.311,
    x2: 61.311,
    y1: 397.548,
    y2: 397.32
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolSummerSwimSvgrepoCom);
export default __webpack_public_path__ + "static/media/pool-summer-swim-svgrepo-com.7710c4d632cf6ec326a401584defad8d.svg";
export { ForwardRef as ReactComponent };